import React, { Component, Fragment } from "react";
import { DropzoneComponent } from "react-dropzone-component";
import Select from "react-select";
import AppContext from "../../../contexts/AppContext";
import Header from "../Header";
import { records, updateProfileData } from "../../../services/userDatails";
import { list } from "../../../services/industry";

export class ProfileSettings extends Component {
    state = {
        company_info: "",
        name: "",
        company_size: "",
        company_website: "",
        company_address: "",
        location_of_HQ: "",
        year_founded: "",
        image: "",
        user_industries: [],
        uid: [],
        industries: [],  
        errors: {}, 
    };

    componentDidMount() {
        list()
        .then(res => {
            this.setState({ industries: res.data });
        })
        .catch(error => {
            this.context.state.handelError(error);
        });
        records()
            .then(res => {
                this.setState({ ...res.data });
            })
            .catch(err => {
                this.context.state.handelError(err);
            });
    }
    updateData = e => {
        if (e.target.value !== "") {
            // required
            //console.log(e.target.id,e.target.value);
            //return false;
            updateProfileData({
                key: e.target.id,
                value: e.target.value
            })
                .then(res => {
                    this.context.state.updateUser(res.data);
                    this.context.state.showCodeMessage(
                        `Your Data has been updated!`,
                        "success"
                    );
                })
                .catch(error => {
                    this.context.state.showCodeMessage(
                        "Something went wrong !",
                        "error"
                    );
                });
        }
    };

    handleSelectChange = selectedOption => {
        let temp = this.state;
        temp["uid"] = [];
        temp["user_industries"] = [];

        if (selectedOption !== null) {
            for (let index = 0; index < selectedOption.length; index++) {
                temp["uid"][index] = selectedOption[index].value;
                temp["user_industries"].push({
                    industry_id: selectedOption[index].value
                });
            }
        }
        let error = this.state.errors;
        error.industries = null;
        //console.log(temp);
        //console.log(this.state.uid);
        this.setState({ uid: temp['uid'], user_industries: temp['user_industries'], errors: error });
        updateProfileData({
            key: "user_industries",
            value: this.state.uid
        })
            .then(res => {
                this.context.state.updateUser(res.data);
                this.context.state.showCodeMessage(
                    `Your Data has been updated!`,
                    "success"
                );
            })
            .catch(error => {
                this.context.state.showCodeMessage(
                    "Something went wrong !",
                    "error"
                );
            });
    };

    updateCompanyWebsite = e => {
        var urlregex = new RegExp(
            "^(http|https|ftp)://([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&amp;%$-]+)*@)*((25[0-5]|2[0-4][0-9]|[0-1]{1}[0-9]{2}|[1-9]{1}[0-9]{1}|[1-9]).(25[0-5]|2[0-4][0-9]|[0-1]{1}[0-9]{2}|[1-9]{1}[0-9]{1}|[1-9]|0).(25[0-5]|2[0-4][0-9]|[0-1]{1}[0-9]{2}|[1-9]{1}[0-9]{1}|[1-9]|0).(25[0-5]|2[0-4][0-9]|[0-1]{1}[0-9]{2}|[1-9]{1}[0-9]{1}|[0-9])|([a-zA-Z0-9-]+.)*[a-zA-Z0-9-]+.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(/($|[a-zA-Z0-9.,?'\\+&amp;%$#=~_-]+))*$"
        );
        if (urlregex.test(e.target.value)) {
            updateProfileData()
                .then(res => {
                    this.context.state.updateUser(res.data);
                    this.context.state.showCodeMessage(
                        `Your company website url has been updated!`,
                        "success"
                    );
                })
                .catch(err => {
                    this.context.state.showCodeMessage(
                        `Something went wrong!`,
                        "error"
                    );
                });
        } else {
            this.context.state.showCodeMessage(
                `Please writer a valid URL!`,
                "error"
            );
        }
    };
    djsConfig = {
        autoProcessQueue: true,
        params: {
            type: "temp",
            fileName: ""
        },

        parallelUploads: 1,
        timeout: 3600,
        headers: {
            Authorization: "Bearer " + localStorage.getItem("auth_token")
        },
        maxFiles: 1,
        maxfilesexceeded: function(file) {
            this.removeAllFiles();
            this.addFile(file);
        },
        error: (file, error) => {
            this.context.state.showCodeMessage(error.message, "error");
        },
        success: (file, response, data) => {
            if (file.status === "success") {
                this.context.state.updateUser(response.data);
                this.context.state.showCodeMessage(
                    "Image uploaded successfully .",
                    "success"
                );
            } else {
                this.context.state.showCodeMessage(
                    "Error while uploading file .",
                    "error"
                );
            }
        }
    };
    handleChange = e => {
        this.setState({ [e.target.id]: e.target.value });
    };

    render() {
        const optionsList = [];
        for (let index = new Date().getFullYear(); index >= 1990; index--) {
            optionsList.push(<option value={index}>{index}</option>);
        }

        return (
            <Fragment>
                <Header></Header>
                <div className="main-content  mt-6">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-12 col-lg-10 col-xl-8">
                                <div className="header">
                                    <div className="header-body">
                                        <div className="row align-items-center">
                                            <div className="col">
                                                <h1 className="header-title">
                                                    Employer Profile
                                                </h1>
                                                <h6 className="header-pretitle">
                                                    Update and manage your
                                                    company details.
                                                </h6>
                                            </div>
                                            <div className="col-auto"></div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-12 col-md-12">
                                        <div className="form-group">
                                            <label htmlFor="name">
                                                Company name
                                            </label>
                                            <input
                                                id="name"
                                                value={this.state.name}
                                                onChange={this.handleChange}
                                                onBlur={this.updateData}
                                                type="text"
                                                className="form-control"
                                            />
                                        </div>
                                    </div>

                                    <hr className="mt-4 mb-5 col-12" />
                                    <div className="col-12 col-md-6">
                                        <div className="row">
                                            <div className="col-12 col-md-4">
                                                <DropzoneComponent
                                                    config={{
                                                        postUrl:
                                                            this.context.state
                                                                .uploadUrl +
                                                            "api/upload/avatar"
                                                    }}
                                                    className="AvatarDropZone"
                                                    djsConfig={this.djsConfig}
                                                >
                                                    <img
                                                        src={
                                                            this.context.state
                                                                .user.image
                                                        }
                                                        alt=""
                                                    ></img>
                                                </DropzoneComponent>
                                            </div>
                                            <div className="col-12 col-md-8 company-logo-text">
                                                <label className="mb-1">
                                                    Company logo
                                                </label>
                                                <small className="form-text text-muted">
                                                    Drag image file to this box
                                                    to update your profile
                                                    picture
                                                </small>
                                            </div>
                                        </div>
                                    </div>
                                    <hr className="mt-4 mb-5 col-12" />

                                    <div className="col-12 col-md-6">
                                        <div className="row">
                                            <div
                                                className="col-12"
                                                style={{
                                                    display: "flex",
                                                    alignItems: "center"
                                                }}
                                            >
                                                <div className="form-group w-100">
                                                    <label htmlFor="location_of_HQ">
                                                        Location of headquarters
                                                    </label>
                                                    <input
                                                        id="location_of_HQ"
                                                        onChange={
                                                            this.handleChange
                                                        }
                                                        onBlur={this.updateData}
                                                        value={
                                                            this.state
                                                                .location_of_HQ || ''
                                                        }
                                                        type="text"
                                                        className="form-control"
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-12">
                                                <div className="form-group">
                                                    <label htmlFor="company_website">
                                                        Company Website
                                                    </label>
                                                    <input
                                                        id="company_website"
                                                        onChange={
                                                            this.handleChange
                                                        }
                                                        value={
                                                            this.state
                                                                .company_website
                                                        }
                                                        onBlur={
                                                            this
                                                                .updateCompanyWebsite
                                                        }
                                                        type="url"
                                                        className="form-control"
                                                    />
                                                </div>
                                            </div>

                                            <div className="col-12">
                                                <div className="form-group">
                                                    <label htmlFor="year_founded">
                                                        Year founded
                                                    </label>
                                                    <select
                                                        id="year_founded"
                                                        maxLength="4"
                                                        onChange={
                                                            this.handleChange
                                                        }
                                                        value={
                                                            this.state
                                                                .year_founded
                                                        }
                                                        onBlur={this.updateData}
                                                        type="text"
                                                        className="form-control"
                                                    >
                                                        {optionsList}
                                                    </select>
                                                </div>
                                            </div>

                                            <div className="col-12 mb-3">
                                                <label htmlFor="company_address">
                                                    Company Address
                                                </label>
                                                <input
                                                    id="company_address"
                                                    onChange={this.handleChange}
                                                    onBlur={this.updateData}
                                                    type="text"
                                                    value={
                                                        this.state
                                                            .company_address
                                                    }
                                                    className="form-control"
                                                    placeholder="Enter your company address"
                                                    autoComplete="off"
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-12 col-md-6">
                                        <div className="row">
                                            <div className="col-12">
                                                <div className="form-group">
                                                    <label htmlFor="company_info">
                                                        Company Overview
                                                    </label>
                                                    <textarea
                                                        placeholder="what you do, why you do it, who you do it for..."
                                                        style={{
                                                            minHeight: "300px"
                                                        }}
                                                        onBlur={this.updateData}
                                                        value={
                                                            this.state
                                                                .company_info
                                                        }
                                                        id="company_info"
                                                        onChange={
                                                            this.handleChange
                                                        }
                                                        rows="12"
                                                        type="text"
                                                        className="form-control"
                                                    ></textarea>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-12 col-md-6  pb-5">
                                        <div className="form-group">
                                            <label htmlFor="company_size">
                                                Company Size
                                            </label>
                                            <select
                                                className="form-control m-input"
                                                data-toggle="select"
                                                id="company_size"
                                                onBlur={this.updateData}
                                                value={this.state.company_size}
                                                onChange={this.handleChange}
                                            >
                                                <option value="1 - 3">
                                                    1 - 3
                                                </option>
                                                <option value="4 - 10">
                                                    4 - 10
                                                </option>
                                                <option value="10 - 100">
                                                    10 - 100
                                                </option>
                                                <option value="100+">
                                                    100+
                                                </option>
                                            </select>
                                        </div>
                                        <div className="form-group">
                                        <label htmlFor="name">Industries <i className="info fe fe-help-circle ml-2" data-toggle="tooltip" data-placement="top" title="Select the industries associated with your website or brand."></i></label>
                                        <div className="industries_container">
                                            
                                            <Select
                                                styles={{
                                                    control: base => ({
                                                        ...base,
                                                        "&:hover": {
                                                            borderColor: "#1cd2ad",
                                                            boxShadow: "none"
                                                        },
                                                        "&": {
                                                            borderColor: "#d2ddec",
                                                            boxShadow: "none"
                                                        }
                                                    }),
                                                    dropdownIndicator: base => ({
                                                        ...base,
                                                        color: "inherit"
                                                    }),
                                                    singleValue: base => ({
                                                        ...base,
                                                        color: "inherit"
                                                    })
                                                }}
                                                isMulti={true}
                                                name="industries"
                                                className="select2"
                                                value={this.state.industries.filter(
                                                    item => {
                                                        const temp = this.state.user_industries.map(
                                                            item => item.industry_id
                                                        );
                                                        return (
                                                            temp.indexOf(item.id) >= 0
                                                        );
                                                    }
                                                )}
                                                onBlur={this.updateData}
                                                onChange={this.handleSelectChange}
                                                options={this.state.industries}
                                            ></Select>
                                        </div>	
                                      
                                    </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}
ProfileSettings.contextType = AppContext;
export default ProfileSettings;



// WEBPACK FOOTER //
// ./src/components/employer/settings/ProfileSettings.js